import { createSlice } from '@reduxjs/toolkit';

import { routerReducer, routerState } from './router';

/** Component Layout Slice. */
export const componentLayoutSlice = createSlice({
  name: 'component_layout',
  initialState: {
    ...routerState,
  },
  reducers: {
    ...routerReducer,
  },
});

/** Component Layout Slice Actions. */
export const componentLayoutSliceActions = componentLayoutSlice.actions;
